/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';
import type { V2beta1PipelineVersionReference } from './V2beta1PipelineVersionReference';
import {
  V2beta1PipelineVersionReferenceFromJSON,
  V2beta1PipelineVersionReferenceFromJSONTyped,
  V2beta1PipelineVersionReferenceToJSON,
  V2beta1PipelineVersionReferenceToJSONTyped,
} from './V2beta1PipelineVersionReference';
import type { V2beta1RecurringRunStatus } from './V2beta1RecurringRunStatus';
import {
  V2beta1RecurringRunStatusFromJSON,
  V2beta1RecurringRunStatusFromJSONTyped,
  V2beta1RecurringRunStatusToJSON,
  V2beta1RecurringRunStatusToJSONTyped,
} from './V2beta1RecurringRunStatus';
import type { V2beta1RuntimeConfig } from './V2beta1RuntimeConfig';
import {
  V2beta1RuntimeConfigFromJSON,
  V2beta1RuntimeConfigFromJSONTyped,
  V2beta1RuntimeConfigToJSON,
  V2beta1RuntimeConfigToJSONTyped,
} from './V2beta1RuntimeConfig';
import type { RecurringRunMode } from './RecurringRunMode';
import {
  RecurringRunModeFromJSON,
  RecurringRunModeFromJSONTyped,
  RecurringRunModeToJSON,
  RecurringRunModeToJSONTyped,
} from './RecurringRunMode';
import type { V2beta1Trigger } from './V2beta1Trigger';
import {
  V2beta1TriggerFromJSON,
  V2beta1TriggerFromJSONTyped,
  V2beta1TriggerToJSON,
  V2beta1TriggerToJSONTyped,
} from './V2beta1Trigger';

/**
 *
 * @export
 * @interface V2beta1RecurringRun
 */
export interface V2beta1RecurringRun {
  /**
   * Output. Unique run ID generated by API server.
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  recurring_run_id?: string;
  /**
   * Required input field. Recurring run name provided by user. Not unique.
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  display_name?: string;
  /**
   * Optional input field. Describes the purpose of the recurring run.
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  description?: string;
  /**
   * This field is Deprecated. The pipeline version id is under pipeline_version_reference for v2.
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  pipeline_version_id?: string;
  /**
   * The pipeline spec.
   * @type {object}
   * @memberof V2beta1RecurringRun
   */
  pipeline_spec?: object;
  /**
   *
   * @type {V2beta1PipelineVersionReference}
   * @memberof V2beta1RecurringRun
   */
  pipeline_version_reference?: V2beta1PipelineVersionReference;
  /**
   *
   * @type {V2beta1RuntimeConfig}
   * @memberof V2beta1RecurringRun
   */
  runtime_config?: V2beta1RuntimeConfig;
  /**
   * Optional input field. Specifies which Kubernetes service account this recurring run uses.
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  service_account?: string;
  /**
   * Required input field.
   * Specifies how many runs can be executed concurrently. Range [1-10].
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  max_concurrency?: string;
  /**
   *
   * @type {V2beta1Trigger}
   * @memberof V2beta1RecurringRun
   */
  trigger?: V2beta1Trigger;
  /**
   *
   * @type {RecurringRunMode}
   * @memberof V2beta1RecurringRun
   */
  mode?: RecurringRunMode;
  /**
   * Output. The time this recurring run was created.
   * @type {Date}
   * @memberof V2beta1RecurringRun
   */
  created_at?: Date;
  /**
   * Output. The last time this recurring run was updated.
   * @type {Date}
   * @memberof V2beta1RecurringRun
   */
  updated_at?: Date;
  /**
   *
   * @type {V2beta1RecurringRunStatus}
   * @memberof V2beta1RecurringRun
   */
  status?: V2beta1RecurringRunStatus;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof V2beta1RecurringRun
   */
  error?: GoogleRpcStatus;
  /**
   * Optional input field. Whether the recurring run should catch up if behind schedule.
   * If true, the recurring run will only schedule the latest interval if behind schedule.
   * If false, the recurring run will catch up on each past interval.
   * @type {boolean}
   * @memberof V2beta1RecurringRun
   */
  no_catchup?: boolean;
  /**
   * TODO (gkclat): consider removing this field if it can be obtained from the parent experiment.
   * Output only. Namespace this recurring run belongs to. Derived from the parent experiment.
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  readonly namespace?: string;
  /**
   * ID of the parent experiment this recurring run belongs to.
   * @type {string}
   * @memberof V2beta1RecurringRun
   */
  experiment_id?: string;
  /**
   * Optional input. Plugin inputs to propagate to each triggered run.
   * Each triggered run will inherit these values in its plugins_input field.
   * @type {{ [key: string]: object; }}
   * @memberof V2beta1RecurringRun
   */
  plugins_input?: { [key: string]: object };
}

/**
 * Check if a given object implements the V2beta1RecurringRun interface.
 */
export function instanceOfV2beta1RecurringRun(value: object): value is V2beta1RecurringRun {
  return true;
}

export function V2beta1RecurringRunFromJSON(json: any): V2beta1RecurringRun {
  return V2beta1RecurringRunFromJSONTyped(json, false);
}

export function V2beta1RecurringRunFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1RecurringRun {
  if (json == null) {
    return json;
  }
  return {
    recurring_run_id: json['recurring_run_id'] == null ? undefined : json['recurring_run_id'],
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    description: json['description'] == null ? undefined : json['description'],
    pipeline_version_id:
      json['pipeline_version_id'] == null ? undefined : json['pipeline_version_id'],
    pipeline_spec: json['pipeline_spec'] == null ? undefined : json['pipeline_spec'],
    pipeline_version_reference:
      json['pipeline_version_reference'] == null
        ? undefined
        : V2beta1PipelineVersionReferenceFromJSON(json['pipeline_version_reference']),
    runtime_config:
      json['runtime_config'] == null
        ? undefined
        : V2beta1RuntimeConfigFromJSON(json['runtime_config']),
    service_account: json['service_account'] == null ? undefined : json['service_account'],
    max_concurrency: json['max_concurrency'] == null ? undefined : json['max_concurrency'],
    trigger: json['trigger'] == null ? undefined : V2beta1TriggerFromJSON(json['trigger']),
    mode: json['mode'] == null ? undefined : RecurringRunModeFromJSON(json['mode']),
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    updated_at: json['updated_at'] == null ? undefined : new Date(json['updated_at']),
    status: json['status'] == null ? undefined : V2beta1RecurringRunStatusFromJSON(json['status']),
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
    no_catchup: json['no_catchup'] == null ? undefined : json['no_catchup'],
    namespace: json['namespace'] == null ? undefined : json['namespace'],
    experiment_id: json['experiment_id'] == null ? undefined : json['experiment_id'],
    plugins_input: json['plugins_input'] == null ? undefined : json['plugins_input'],
  };
}

export function V2beta1RecurringRunToJSON(json: any): V2beta1RecurringRun {
  return V2beta1RecurringRunToJSONTyped(json, false);
}

export function V2beta1RecurringRunToJSONTyped(
  value?: Omit<V2beta1RecurringRun, 'namespace'> | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    recurring_run_id: value['recurring_run_id'],
    display_name: value['display_name'],
    description: value['description'],
    pipeline_version_id: value['pipeline_version_id'],
    pipeline_spec: value['pipeline_spec'],
    pipeline_version_reference: V2beta1PipelineVersionReferenceToJSON(
      value['pipeline_version_reference'],
    ),
    runtime_config: V2beta1RuntimeConfigToJSON(value['runtime_config']),
    service_account: value['service_account'],
    max_concurrency: value['max_concurrency'],
    trigger: V2beta1TriggerToJSON(value['trigger']),
    mode: RecurringRunModeToJSON(value['mode']),
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    updated_at:
      value['updated_at'] == null ? value['updated_at'] : value['updated_at'].toISOString(),
    status: V2beta1RecurringRunStatusToJSON(value['status']),
    error: GoogleRpcStatusToJSON(value['error']),
    no_catchup: value['no_catchup'],
    experiment_id: value['experiment_id'],
    plugins_input: value['plugins_input'],
  };
}
